import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ModalCloserService} from '../../modal-closer.service';
import {AppointmentsService} from '../../Services/appointments/appointments.service';
import {CookieService} from 'angular2-cookie/services/cookies.service';

@Component({
  selector: 'app-desktop-add-to-calendar',
  templateUrl: './desktop-add-to-calendar.component.html',
  styleUrls: ['./desktop-add-to-calendar.component.scss']
})
export class DesktopAddToCalendarComponent implements OnInit {

  googleLink: string;
  outlook: string;

  @Output() close = new EventEmitter();

  modalCloser: ModalCloserService;
  appointmentService: AppointmentsService;

  constructor(modalCloser: ModalCloserService, appointmentService: AppointmentsService) {
    this.modalCloser = modalCloser;
    this.appointmentService = appointmentService;
    this.googleLink = CookieService.prototype.get('appointmentGoogle');
    this.outlook = CookieService.prototype.get('appointmentOutlook');
  }

  ngOnInit() {
  }

  closeModal() {
    document.getElementById('close-modal').click();
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/desktop-add-to-calendar/desktop-add-to-calendar.component.ts